export const API_COUPON_LIST = '/integral/web/rewardRedeemCoupon/cart/coupon/listForWeb';
export const API_USER_INFO = '/integral/web/aiRecommend/userInfo';

export const API_USER_CART_PAGE = '/shopify/web/shopifyCart/page';
export const API_USER_CART_INCREASE = '/shopify/web/shopifyCart/increase'; // quantity 增量
export const API_USER_CART_CHANGE = '/shopify/web/shopifyCart/change'; // quantity: 全量
export const API_USER_CART_MERGE = '/shopify/web/shopifyCart/merge'; // 合并，同时存在则取大
